import { UserOutlined } from "@ant-design/icons";
import { Avatar, Tooltip } from "antd";
import Button from "components/Button";
import Grid from "components/Grid";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { format, formatDistance } from "date-fns";
import model from "images/model.jpg";
import { gender } from "pages/Profile/EditProfile/PhysicalDetails/constants";
import { FC } from "react";
import { BiDollar } from "react-icons/bi";
import {
    IoCalendarClearOutline,
    IoLocationOutline,
    IoMaleFemaleOutline,
} from "react-icons/io5";
import { LiaBirthdayCakeSolid } from "react-icons/lia";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setModelProfile } from "slice/model";
import theme from "theme";
import {
    CardChip,
    CardContent,
    CardImage,
    CardLeft,
    CardRight,
    CardTitle,
    HorizontalCard,
    Info,
    ItalicText,
    Posted,
} from "./MyJobListings.styled";
import { AgencyJob } from "./types";
import { useMyJobListings } from "./useMyJobListings";
export interface MyJobCardProps {
    job: AgencyJob;
}

export const MyJobCard: FC<MyJobCardProps> = ({ job }) => {
    const { handleEditJob } = useMyJobListings();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return (
        <HorizontalCard>
            <CardImage src={model} alt="model image" />
            <CardContent>
                <CardLeft>
                    <CardTitle>
                        <Text variant="heading4">{job.title}</Text>
                        <CardChip variant="body2">Featured</CardChip>
                    </CardTitle>
                    {/* <Text variant="body3" color={theme.colors.grey.secondary}>
                        {job.no_of_seats} {job.gender}s, {job.ageMin}-
                        {job.ageMax} yrs
                    </Text> */}
                    <Grid row={true} columnGap={2} marginTop={1}>
                        <Info>
                            <IoMaleFemaleOutline />
                            <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                {job.no_of_seats +
                                    " " +
                                    gender[job.gender as keyof typeof gender]}
                            </Text>
                        </Info>
                        <Info>
                            <LiaBirthdayCakeSolid />

                            <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                {(job.ageMin ?? 0) + "yrs"} -{" "}
                                {(job.ageMax ?? 0) + "yrs"}
                            </Text>
                        </Info>
                    </Grid>
                    <Grid row={true} columnGap={2} marginTop={1}>
                        <Info>
                            <BiDollar />
                            <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                {job.budget_type}
                            </Text>
                        </Info>
                        <Info>
                            <IoLocationOutline />
                            <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                {job.location}
                            </Text>
                        </Info>
                        <Info>
                            <IoCalendarClearOutline />
                            <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                {format(
                                    new Date(job.created_at),
                                    "dd MMM yyyy"
                                )}
                            </Text>
                        </Info>
                    </Grid>
                    <Grid row={true} alignItems="center" marginTop={1}>
                        {/* <AgencyImage src={agencyLogo} alt="agency image" />
                        <Text variant="body3" color={theme.colors.grey.primary}>
                            VK Agency{" "}
                            <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                (4.2)
                            </Text>
                        </Text> */}
                        {job.applicants} applicants{" "}
                    </Grid>
                    {(job?.applicants_list || [])?.length > 0 && (
                        <Grid row={true} alignItems="center" marginTop={1}>
                            <Avatar.Group
                                size={"small"}
                                max={{
                                    count: 10,
                                    style: {
                                        backgroundColor: "#B49EF9",
                                    },
                                }}
                            >
                                {job?.applicants_list?.map((val) => {
                                    return (
                                        <Tooltip title={val.user_email}>
                                            <Avatar
                                                style={{
                                                    backgroundColor: "#B49EF9",
                                                }}
                                                onClick={() => {
                                                    dispatch(
                                                        setModelProfile(
                                                            undefined
                                                        )
                                                    );
                                                    navigate(
                                                        routeConstants
                                                            .findTalentRoot
                                                            .root +
                                                            routeConstants
                                                                .findTalentRoot
                                                                .model,
                                                        {
                                                            state: {
                                                                model_id:
                                                                    val.user_id,
                                                            },
                                                        }
                                                    );
                                                }}
                                                size="small"
                                                icon={<UserOutlined />}
                                            />
                                        </Tooltip>
                                    );
                                })}
                            </Avatar.Group>
                        </Grid>
                    )}
                </CardLeft>
                <CardRight>
                    <Grid row={true} columnGap={2} alignItems="center">
                        {/* <Text
                            variant="body3"
                            color={theme.colors.green.primary}
                        >
                            75% Match
                        </Text> */}
                        <Button
                            variant="outlined"
                            onClick={() => handleEditJob(job?.id)}
                        >
                            Edit Job
                        </Button>
                    </Grid>
                    <Posted variant="body3" color={theme.colors.grey.secondary}>
                        <ItalicText>
                            Last Modified:{" "}
                            {formatDistance(
                                new Date(job.updated_at),
                                new Date()
                            )}{" "}
                            ago
                        </ItalicText>
                    </Posted>
                </CardRight>
            </CardContent>
        </HorizontalCard>
    );
};
